import { rei } from "@/services/api"

class ReleasesNotesService {
  static getAllReleases () {
    return rei.get(`releases-notes`).then(res => res.data)
  }

  static getRelease (versionNumber) {
    return rei.get(`releases-notes/${versionNumber}`).then(res => res.data)
  }

  static getAllSubcategory () {
    return rei.get(`releases-notes/get-all-subcategories`).then(res => res.data)
  }

  static getReleasesBySubcategory (params) {
    return rei.get(`releases-notes/get-releases-by-subcategory`, {params}).then(res => res.data)
  }

  static getReleasesByCategory (params) {
    return rei.get(`releases-notes/get-releases-by-category`,  {params}).then(res => res.data)
  }
}

export default ReleasesNotesService
